<template>
    <div :class="classes.root">
        <i v-if="icon" :class="classes.icon" v-b-tooltip :title="iconTooltip"></i>
        <div class="chips-content">
            <slot></slot>
        </div>
        <span v-if="close" class="chips-close-btn">
            <i class="fas fa-times"></i>
        </span>
    </div>
</template>

<script>
    export default {
        name: "chips",
        props: {
            variant: {type: String, default: 'ligth'},
            icon: {type: String, default: null},
            iconVariant: {type: String, default: 'default'},
            iconTooltip: {type: String, default: null},
            disabled: {type: Boolean, default: false},
            close: {type: Boolean, default: false},
            active: {type: Boolean, default: false},
            size: {type: String, default: null},
            outline: {type: Boolean, dafault: false}
        },
        computed: {
            classes() {
                return {
                    root: {
                        'chips': true,
                        ['chips-' + (this.outline ? 'outline-' : '') + this.variant]: true,
                        'chips-disabled': this.disabled,
                        'chips-hovered': !!this.$listeners.click
                    },
                    icon: {
                        'chips-icon': true,
                        'far': true,
                        ['fa-' + (this.icon ? this.icon : '')]: !!this.icon,
                        ['text-' + this.iconVariant]: true
                    }
                }
            },
        }
    }
</script>

<style lang="scss">
    @import "./chips";
</style>